import { render, staticRenderFns } from "./Coluna3.vue?vue&type=template&id=56c09dfc&"
import script from "./Coluna3.vue?vue&type=script&lang=js&"
export * from "./Coluna3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports